// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestComplianceService: () => UseMutationResult<
  void,
  string,
  {
    operator: string;
    compliance: string;
    upgrader: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryComplianceService', ledgerApi, party],
    mutationFn: async ({ operator, compliance, upgrader }) => {
      return ledgerApi.requestRegistryComplianceService(operator, compliance, upgrader);
    },
    retry: false,
  });
};

export default useRequestComplianceService;
